import { EnumLanguages } from '@m4u-angular/core/framework/sysenums.enum';

export const Lists_EN =
{
    Properties:
    {
        Language: EnumLanguages.English
    },
}